/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMSAxMlYxMS4ySDkuNTY3MjVWMTJIMVpNMTIuNDY5MiAxMC4yNzdMOS4zNjgzMSA3TDEyLjQ2OTIgMy43Mzg0TDEzIDQuMzA0NkwxMC40Mjk4IDdMMTMgOS43MTA4TDEyLjQ2OTIgMTAuMjc3Wk0xIDcuNFY2LjZINy40MzI3NVY3LjRIMVpNMSAyLjhWMkg5LjU2NzI1VjIuOEgxWiIgZmlsbD0iYmxhY2siLz48L3N2Zz4=";